import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { SubscriptionPlan } from '../data/subscriptionPlans';
import { HomeHeader } from '../components/home/HomeHeader';
import { AnsweringStatusCard, CardAction } from '../components/home/AnsweringStatusCard';
import { AnsweringRulesSheet } from '../components/home/AnsweringRulesSheet';
import { TodaysOverview } from '../components/home/TodaysOverview';
import type { ForwardingAction, ForwardingConnection } from '../types/forwarding';
import { deriveDashboardState } from '../utils/forwardingStatus';
interface HomeScreenProps {
  onNavigate: (screen: string) => void;
  /** The connected (or partly connected) number. Null = never connected. */
  connection?: ForwardingConnection | null;
  /** Subscription state is shown separately from forwarding state. */
  subscriptionActive?: boolean;
  /** Selected package, used to keep allowance summaries in sync with billing. */
  plan?: SubscriptionPlan;
  onForwardingAction?: (action: ForwardingAction) => void;
}
export function HomeScreen({
  onNavigate,
  connection = null,
  subscriptionActive = false,
  plan,
  onForwardingAction
}: HomeScreenProps) {
  const {
    isLight
  } = useTheme();
  const [rulesOpen, setRulesOpen] = useState(false);
  const state = deriveDashboardState(connection);
  const handleAction = (a: CardAction) => {
    if (a.type === 'manage') setRulesOpen(true);else onForwardingAction?.(a);
  };
  return <div className="relative h-full overflow-y-auto pb-36" data-id="element-2379" data-mp="b15snlxby2df">
      <div className={`pointer-events-none absolute right-0 top-0 h-64 w-64 rounded-full blur-3xl ${isLight ? 'bg-vexu/10' : 'bg-vexu/5'}`} data-id="element-2380" data-mp="62kvxwhae0tq" />
      <div className="relative z-10 space-y-8 p-6" data-id="element-2381" data-mp="19rp9329cif0">
        <HomeHeader onNavigate={onNavigate} data-id="element-2382" data-mp="3shnqb4ccpubl" />
        <AnsweringStatusCard state={state} connection={connection} subscriptionActive={subscriptionActive} onAction={handleAction} data-id="element-2383" data-mp="3sgkxurzdrjtk" />
        {/* A first-time account has no activity yet; returning users keep their history. */}
        <TodaysOverview hasData={state !== 'firstTime'} onNavigate={onNavigate} minutesTotal={plan?.minutes ?? 180} data-id="element-2384" data-mp="2jacbsyxfptxg" />
      </div>
      <AnsweringRulesSheet open={rulesOpen} connection={connection} onClose={() => setRulesOpen(false)} onAction={a => onForwardingAction?.(a)} data-id="element-2385" data-mp="29jr66rjcfp51" />
    </div>;
}